module.exports = __webpack_public_path__ + "static/media/IMG_20180303_201748.0167b009.webp";